import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBlocks = () => {
  return (
    <g>
      <path d="M16 15.253a.747.747 0 0 1-.747.747H.747A.747.747 0 0 1 0 15.253v-4.906C0 9.934.334 9.6.747 9.6H4.8V5.547c0-.413.334-.747.747-.747H9.6V.747c0-.413.334-.747.747-.747h4.906c.413 0 .747.334.747.747v14.506zM4.8 11.2H1.6v3.2h3.2v-3.2zm4.8 0H6.4v3.2h3.2v-3.2zm4.8 0h-3.2v3.2h3.2v-3.2zM9.6 6.4H6.4v3.2h3.2V6.4zm4.8 0h-3.2v3.2h3.2V6.4zm0-4.8h-3.2v3.2h3.2V1.6z" />
    </g>
  );
};

export default withIcon(IconBlocks);
